import React, { useState } from 'react';
import { X } from 'lucide-react';

const GalleryGrid = ({ items }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [showBefore, setShowBefore] = useState(true);

  const openModal = (item) => {
    setSelectedItem(item);
    setShowBefore(true);
  };

  const closeModal = () => {
    setSelectedItem(null);
  };

  return (
    <>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '24px'
      }}>
        {items.map((item) => (
          <div
            key={item.id}
            className="gallery-card"
            onClick={() => openModal(item)}
          >
            <div style={{position: 'relative', height: '300px', overflow: 'hidden'}}>
              <img
                src={item.after}
                alt={item.title}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease'
                }}
              />
              <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                padding: '40px 20px 20px'
              }}>
                <span className="caption" style={{color: 'white', display: 'block', marginBottom: '4px'}}>{item.category}</span>
                <h3 className="heading-5" style={{color: 'white'}}>{item.title}</h3>
              </div>
            </div>
            <div style={{padding: '16px'}}>
              <p className="body-small" style={{color: 'var(--text-secondary)'}}>{item.description}</p>
              <button className="caption" style={{
                marginTop: '12px',
                color: 'var(--text-secondary)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '0',
                textTransform: 'uppercase',
                letterSpacing: '0.1em'
              }}>
                VIEW BEFORE & AFTER
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedItem && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.95)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          overflowY: 'auto'
        }} onClick={closeModal}>
          <div style={{
            maxWidth: '1200px',
            width: '100%',
            position: 'relative',
            margin: 'auto'
          }} onClick={(e) => e.stopPropagation()}>
            <button
              onClick={closeModal}
              style={{
                position: 'absolute',
                top: '-40px',
                right: '0',
                background: 'none',
                border: 'none',
                color: 'white',
                cursor: 'pointer',
                padding: '8px',
                zIndex: 10
              }}
            >
              <X size={32} />
            </button>
            
            <div style={{background: 'var(--bg-card)', borderRadius: '8px', overflow: 'hidden'}} className="gallery-modal-content">
              <div className="gallery-modal-images">
                <div className="gallery-modal-image-container">
                  <img
                    src={selectedItem.before}
                    alt="Before"
                    className="gallery-modal-image"
                  />
                  <div style={{
                    position: 'absolute',
                    top: '20px',
                    left: '20px',
                    background: 'rgba(0,0,0,0.7)',
                    padding: '8px 16px',
                    borderRadius: '4px'
                  }}>
                    <span className="caption" style={{color: 'white'}}>BEFORE</span>
                  </div>
                </div>
                <div className="gallery-modal-image-container">
                  <img
                    src={selectedItem.after}
                    alt="After"
                    className="gallery-modal-image"
                  />
                  <div style={{
                    position: 'absolute',
                    top: '20px',
                    left: '20px',
                    background: 'var(--brand-primary)',
                    padding: '8px 16px',
                    borderRadius: '4px'
                  }}>
                    <span className="caption" style={{color: 'white'}}>AFTER</span>
                  </div>
                </div>
              </div>
              <div style={{padding: '32px'}}>
                <span className="caption" style={{color: 'var(--text-secondary)', display: 'block', marginBottom: '8px'}}>{selectedItem.category}</span>
                <h3 className="heading-4" style={{color: 'var(--text-primary)', marginBottom: '12px'}}>{selectedItem.title}</h3>
                <p className="body-medium" style={{color: 'var(--text-secondary)'}}>{selectedItem.description}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GalleryGrid;